/**
 * @fileoverview O bloco "Agente IA" e os agentes de IA (bloco 3b dos planos).
 * Com agentId, o bloco usa o agente: o texto, as fontes e a inteligência vêm
 * dele. Sem agente e com o campo do texto, é o "Personalizado", de antes dos
 * agentes (o campo vazio continua sendo: a pessoa pode estar reescrevendo, e
 * o servidor não deixa ativar assim). Sem os dois, falta escolher o agente.
 * Os nomes dos agentes chegam ao desenho do fluxo pelo AgentOptionsContext.
 */

import React from "react";

// A lista leve dos agentes ({ id, name, profilePicUrl }), ou null enquanto carrega.
// Fora do editor (o percurso nos resultados), não há lista.
export const AgentOptionsContext = React.createContext(null);

// As ferramentas que viram fontes do agente: com agente, o fluxo não as usa.
export const KNOWLEDGE_TOOL_TYPES = ["tool_files", "tool_memory", "tool_websearch", "tool_woocommerce"];

// "agent": usa um agente; "custom": o texto está no bloco; "empty": falta escolher.
export const agentNodeMode = (data) => {
  if (data && Number(data.agentId) > 0) return "agent";
  return data && typeof data.prompt === "string" ? "custom" : "empty";
};
